export default __webpack_public_path__ + "static/media/luize_bairros.c00e8c88.jpg";